import { generateID, isMailInAction, nullishFilter } from '@caresend/utils';
import { getStore } from '../../../../../store/helpers/initStore.js';

/**
 * Returns the ScannableItemWithKey for the specimen bag of a procedure for
 * drop off workflow
 */
const getDropOffScanSpecimenBag = (procedure, patientName) => {
    var _a;
    const { specimenBag } = procedure;
    if (!specimenBag)
        return { items: [], title: 'Nothing to verify' };
    const store = getStore();
    const supply = store.getters['variables/getSupplyByID'](specimenBag.supplyID);
    let title;
    if (patientName && (supply === null || supply === void 0 ? void 0 : supply.name)) {
        title = `Scan the ${supply.name.toLowerCase()} for ${patientName}`;
    }
    else if (supply === null || supply === void 0 ? void 0 : supply.name) {
        title = `Scan the ${supply === null || supply === void 0 ? void 0 : supply.name.toLowerCase()}`;
    }
    return {
        items: [{
                ...specimenBag,
                name: (_a = supply === null || supply === void 0 ? void 0 : supply.name) !== null && _a !== void 0 ? _a : 'Specimen bag',
                key: generateID(),
                isScanned: false,
            }],
        title: title !== null && title !== void 0 ? title : 'Scan the specimen bag',
    };
};
const getMailInBoxSupply = (waypointAction) => {
    var _a, _b, _c;
    const mailInBoxSupplyID = isMailInAction(waypointAction) ? waypointAction.mailInBoxSupplyID : undefined;
    const store = getStore();
    const mailInBoxSupply = mailInBoxSupplyID ? store.getters['variables/getSupplyByID'](mailInBoxSupplyID) : undefined;
    const title = `Scan the ${(_b = (_a = mailInBoxSupply === null || mailInBoxSupply === void 0 ? void 0 : mailInBoxSupply.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : 'shipping supply'}`;
    return {
        items: [{
                supplyID: mailInBoxSupplyID,
                name: (_c = mailInBoxSupply === null || mailInBoxSupply === void 0 ? void 0 : mailInBoxSupply.name) !== null && _c !== void 0 ? _c : 'Shipping supply',
                key: generateID(),
                isScanned: false,
            }],
        title,
    };
};
const getPackingScanSpecimenBags = (procedures) => {
    const store = getStore();
    const items = procedures.map((procedure) => procedure.specimenBag).filter(nullishFilter).map((itemWithSupplyID) => {
        var _a;
        const supplyItem = store.getters['supplies/getSupplyItemByID'](itemWithSupplyID.id);
        const supply = store.getters['variables/getSupplyByID'](itemWithSupplyID.supplyID);
        return {
            color: supply === null || supply === void 0 ? void 0 : supply.color,
            imageColor: supply === null || supply === void 0 ? void 0 : supply.imageColor,
            isScanned: false,
            key: generateID(),
            name: (_a = `${supply === null || supply === void 0 ? void 0 : supply.name} - ${itemWithSupplyID.id.slice(-4)}`) !== null && _a !== void 0 ? _a : 'Unknown supply',
            skuID: supplyItem === null || supplyItem === void 0 ? void 0 : supplyItem.skuID,
            supplyID: itemWithSupplyID.supplyID,
        };
    });
    return {
        items,
        title: 'Scan specimen bags',
    };
};
/** Offices may override kitSupplyID for particular tasks */
const getOfficeKitSupplyID = (procedure) => {
    var _a;
    return (_a = getStore().state.supplies
        .proceduresOfficeSupplyConfig[procedure.id]) === null || _a === void 0 ? void 0 : _a.supplyConfig.kitSupplyID;
};
const getTaskKitSupplyID = (procedure, offline) => {
    var _a;
    const { taskID } = procedure;
    const key = offline ? 'offlineKitSupplyID' : 'kitSupplyID';
    return (_a = getStore().getters['variables/getTaskByID'](taskID)) === null || _a === void 0 ? void 0 : _a[key];
};
/**
 * Pass `offline` if nurse is packing rather than warehouse. If warehouse is
 * packing, `offline` is always `false`.
 */
const getInitialProcedureKitSupply = (procedure, offline) => {
    var _a, _b;
    const scannableItemProps = {
        items: [],
        title: 'Procedure Kit Supply',
    };
    if (!procedure)
        return scannableItemProps;
    let id;
    if (offline)
        id = getTaskKitSupplyID(procedure, offline);
    else
        id = (_a = getOfficeKitSupplyID(procedure)) !== null && _a !== void 0 ? _a : getTaskKitSupplyID(procedure);
    if (!id)
        return scannableItemProps;
    const supply = getStore().getters['variables/getSupplyByID'](id);
    scannableItemProps.items.push({
        supplyID: id,
        name: (_b = supply === null || supply === void 0 ? void 0 : supply.name) !== null && _b !== void 0 ? _b : 'Procedure kit supply',
        key: generateID(),
        isScanned: false,
    });
    return scannableItemProps;
};

export { getDropOffScanSpecimenBag, getInitialProcedureKitSupply, getMailInBoxSupply, getPackingScanSpecimenBags };
